var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1612_3471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68934 3.93934C2.97064 3.65804 3.35217 3.5 3.75 3.5H20.25C20.6478 3.5 21.0294 3.65804 21.3107 3.93934C21.592 4.22065 21.75 4.60218 21.75 5V17C21.75 17.3978 21.592 17.7794 21.3107 18.0607C21.0294 18.342 20.6478 18.5 20.25 18.5H7.78907L7.6923 18.5353L4.71522 21.0379C4.49656 21.2217 4.22997 21.3393 3.9468 21.3768C3.66362 21.4142 3.37563 21.3701 3.11669 21.2495C2.85775 21.1289 2.63863 20.9368 2.48509 20.696C2.33156 20.4551 2.25 20.1754 2.25 19.8897V5C2.25 4.60217 2.40804 4.22064 2.68934 3.93934ZM20.25 5L3.75 5L3.75 19.8897L6.82845 17.3019C6.8955 17.2455 6.97192 17.2013 7.05422 17.1713L7.39982 17.0453C7.48212 17.0153 7.56905 17 7.65665 17H20.25V5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 9.5C8.25 9.08579 8.58579 8.75 9 8.75H15C15.4142 8.75 15.75 9.08579 15.75 9.5C15.75 9.91421 15.4142 10.25 15 10.25H9C8.58579 10.25 8.25 9.91421 8.25 9.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 12.5C8.25 12.0858 8.58579 11.75 9 11.75H15C15.4142 11.75 15.75 12.0858 15.75 12.5C15.75 12.9142 15.4142 13.25 15 13.25H9C8.58579 13.25 8.25 12.9142 8.25 12.5Z",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.175c227de7b1c707db1175c76e7046c1.svg";
export { ForwardRef as ReactComponent };